import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('dental_benefits_set', '/dental_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
